import App from '../App'

export default class Menu {
    constructor() {
        this.menuOpen = false
        this.isAnimating = false

        this.bindMethods()
        this.getElems()
        this.addEvents()
    }

    bindMethods() {
        this.toggle = this.toggle.bind(this)
        this.onItemClick = this.onItemClick.bind(this)
        this.onLogoClick = this.onLogoClick.bind(this)
        this.onOverlayClick = this.onOverlayClick.bind(this)
    }

    getElems() {
      this.header = document.querySelector('.header')
      this.toggler = this.header.querySelector('.header__toggler')
      this.menu = this.header.querySelector('.header__menu')
      this.innerMenu = this.header.querySelector('.header__menu-inner')
      this.items = this.header.querySelectorAll('.navigation__item')
      this.links = this.header.querySelectorAll('.navigation__item-link')
      this.menuButtons = this.header.querySelectorAll('.icon-button')
      this.homeLink = this.header.querySelector('.header__logo')
      this.navbar = this.header.querySelector('.navbar-col')
      this.overlay = this.header.querySelector('.header__overlay')
    }

    addEvents() {
      this.toggler && this.toggler.addEventListener('click', this.toggle)

      this.homeLink.addEventListener('click', this.onLogoClick)
      this.overlay.addEventListener('click', this.onOverlayClick)

      for (let i = 0; i < this.links.length; i++) {
        this.links[i].addEventListener('click', this.onItemClick)
      }
    }

    onItemClick() {
      this.close()
    }

    onOverlayClick() {
      this.close()
    }

    onLogoClick() {
      if (!this.menuOpen) return;

      this.close()
    }

    onPageChange(renderer) {
      this.renderer = renderer
      this.addActiveToCurrentView(this.renderer)
    }

    addActiveToCurrentView(renderer) {
      if (renderer) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].dataset.id === renderer.view.dataset.id) {
            this.items[i].classList.add('active')
          } else {
            this.items[i].classList.remove('active')
          }
        }
      }
    }

    /**
     * Toggle Menu to open or close it
     * @returns {any} null
     */
    toggle() {
        if (this.isAnimating) return

        if (this.menuOpen) this.close()
        else this.open()
    }

    /**
     * Open Menu
     * @returns {Promise} return Promise when open animation end
     */
    open() {
      return new Promise((resolve) => {
        this.menuOpen = true
        this.isAnimating = true
        this.toggler.classList.add('open')

        this.disableScroll()

        const tl = new TimelineLite({
          onComplete: () => {
            this.isAnimating = false
            resolve()
          }
        })

        tl.addLabel('start', 0)

        tl.to(this.menu, 1.2, {
          x: '0%',
          ease: Expo.easeOut
        }, 'start')
        tl.to(this.innerMenu, 1.2, {
          x: '0%',
          ease: Expo.easeOut
        }, 'start')
        tl.staggerTo(this.items, 1.2, {
          delay: 0.1,
          alpha: 1,
          x: '0%',
          ease: Expo.easeOut
        }, 0.03, 'start')

        document.body.classList.add('menu-open')
      })
    }

    /**
     * Close Menu
     * @returns {Promise} return Promise when close animation end
     */
    close() {
      return new Promise((resolve) => {
        this.menuOpen = false
        this.isAnimating = true
        this.toggler.classList.remove('open')

        this.enableScroll()

        const tl = new TimelineLite({
          onComplete: () => {
            this.isAnimating = false
            resolve()
          }
        })

        tl.addLabel('start', 0)

        tl.staggerTo(this.items, 1.2, {
          x: '-50%',
          alpha: 0,
          ease: Expo.easeInOut
        }, -0.03)
        tl.to(this.menu, 1.2, {
          delay: 0.25,
          x: '-100%',
          ease: Expo.easeInOut
        }, 'start')
        tl.to(this.innerMenu, 1.2, {
          delay: 0.25,
          x: '100%',
          ease: Expo.easeInOut
        }, 'start')

        document.body.classList.remove('menu-open')
      })
    }

    disableScroll() {
      if (App.isMobile) window.addEventListener('touchmove', this.preventDefault, { passive: false })
      else if (App.smoothScroll && !App.isMobile) App.smoothScroll.stop()
      else window.addEventListener('wheel', this.preventDefault, { passive: false })
    }

    enableScroll() {
      if (App.isMobile) window.removeEventListener('touchmove', this.preventDefault, { passive: false })
      else if (App.smoothScroll && !App.isMobile) App.smoothScroll.start()
      else window.removeEventListener('wheel', this.preventDefault, { passive: false })
    }

    preventDefault(ev) {
      ev.preventDefault();
    }

    resize() {}

	scroll() {}
}



// WEBPACK FOOTER //
// ./scripts/util/Menu.js